"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.homepageOptions = exports.prefs = void 0;
var prefs = [
    {
        id: 670,
        version: 0,
        section: "user_preference",
        keyname: "codametrix.user.preference.default_service_line",
        ownerId: 2734,
        values: [
            {
                id: 673,
                value: "1",
                tenantId: null,
                preferenceId: 670,
                version: 0
            }
        ],
        firstValue: "1"
    },
    {
        id: 762,
        version: 0,
        section: "user_preference",
        keyname: "codametrix.user.preference.default_user_context",
        ownerId: 2734,
        values: [
            {
                id: 801,
                value: "2",
                tenantId: null,
                preferenceId: 762,
                version: 0
            }
        ],
        firstValue: "2"
    },
    {
        id: 876,
        version: 0,
        section: "user_preference",
        keyname: "codametrix.user.preference.default_homepage",
        ownerId: 2734,
        values: [
            {
                id: 730,
                value: "cases",
                tenantId: "1",
                preferenceId: 893,
                version: 0
            }
        ],
        firstValue: "cases"
    }
];
exports.prefs = prefs;
var homepageOptions = [
    {
        label: "Analytics",
        path: "analytics/"
    },
    {
        label: "Cases",
        path: "cases/"
    },
    {
        label: "Admin: Users",
        path: "admin/users/"
    },
    {
        label: "Admin: Organizations",
        path: "admin/orgs/"
    },
    {
        label: "None",
        path: "None"
    }
];
exports.homepageOptions = homepageOptions;
//# sourceMappingURL=preferences.js.map